module.exports = __webpack_public_path__ + "img/replay-button.2c27aa9e.png";